import React from 'react';
import styled from 'styled-components';

import {getCellBackgroundColor, getCellIndexStyles, getCellTextColor} from '../helpers/tableCellHelpers';
import {getStickyStyles, getWidthSettingsStyles} from '../tableColumn';
import {MaybeRenderStickyContainerCell} from './stickyContainerCell';
import {TableCellProps, TableCellStyleProps} from './tableCell';

/*
 * Styles.
 */

const StyledEmptyCellContainerDiv = styled.div<TableCellStyleProps>`
  padding: 0 12px;
  display: flex;
  white-space: nowrap;
  align-items: center;

  ${(p) => getCellBackgroundColor(p.$isHovering, p.$isSelected)}
  ${(p) => getStickyStyles({isSticky: Boolean(p.$settings?.sticky)})}
  ${(p) => getWidthSettingsStyles(p.$settings?.cellWidth)}
  ${(p) =>
    getCellIndexStyles(
      p.$index,
      p.$isSelected,
      p.$shouldRemoveTopBorderRadius,
      p.$shouldRemoveBottomBorderRadius,
    )}
`;

interface StyledEmptyValueDivProps {
  $isSelected: boolean;
}
const StyledEmptyValueDiv = styled.div<StyledEmptyValueDivProps>`
  ${(p) => getCellTextColor(p.$isSelected, p.theme.greys.shade60)}
`;

/*
 * Component.
 */

export const EmptyCell = (props: TableCellProps<unknown>) => {
  const {
    settings,
    isHovering,
    isSelected,
    index,
    shouldShowStickyGradient,
    shouldRemoveTopBorderRadius,
    shouldRemoveBottomBorderRadius,
  } = props;
  return (
    <MaybeRenderStickyContainerCell
      settings={settings}
      index={index}
      shouldShowStickyGradient={shouldShowStickyGradient}
    >
      <StyledEmptyCellContainerDiv
        $settings={settings}
        $isHovering={Boolean(isHovering)}
        $isSelected={Boolean(isSelected)}
        $index={index}
        $shouldRemoveTopBorderRadius={shouldRemoveTopBorderRadius}
        $shouldRemoveBottomBorderRadius={shouldRemoveBottomBorderRadius}
      >
        <StyledEmptyValueDiv $isSelected={Boolean(isSelected)}>--</StyledEmptyValueDiv>
      </StyledEmptyCellContainerDiv>
    </MaybeRenderStickyContainerCell>
  );
};
